import React from 'react'
import { TextField } from 'react-admin'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const LocationList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props}>
    <TextField source="supplierName" label="Location Supplier" />
    <TextField source="peopleCapacity" />
    <TextField source="locationZone" />
    <TextField source="status" label="Location Status" />
  </MainProductList>
)

export default LocationList
